import React, { useMemo } from 'react';
import { Empty, Spin } from 'antd';
import cn from 'classnames';
import FetchError from '../FetchError';
import styles from './index.module.scss';

const states = {
  empty: 'empty',
  error: 'error',
  success: 'success',
};

const FetchDataWrapper = ({
  data,
  isFetching = false,
  ignoreEmpty = false,
  refetch,
  errMsg,
  errorActionSlot,
  className,
  children,
}) => {
  const state = useMemo(() => getState(data, ignoreEmpty), [data, ignoreEmpty]);

  const content = useMemo(
    () => renderContent({ state, errMsg, refetch, errorActionSlot }),
    [state, errMsg, refetch, errorActionSlot]
  );

  return (
    <Spin spinning={isFetching} wrapperClassName={cn(styles.root, className)}>
      {content ?? children}
    </Spin>
  );
};

export default FetchDataWrapper;

function getState(data, ignoreEmpty) {
  if (!data || isEmpty(data, ignoreEmpty)) {
    return states.empty;
  }

  if (data === 'Error') {
    return states.error;
  }

  return states.success;
}

function isEmpty(data, ignoreEmpty) {
  if (data === undefined || data === null) {
    return true;
  }

  if (ignoreEmpty) {
    return false;
  }

  const type = typeof data;

  if (type === 'string') {
    return !data.trim();
  }

  if (type === 'number' || type === 'boolean') {
    return false;
  }

  if (type === 'object') {
    if (Array.isArray(data)) {
      return data.length === 0;
    }

    if (data instanceof Set || data instanceof Map) {
      return data.size === 0;
    }

    return Object.keys(data).length === 0;
  }

  return true;
}

function renderContent({ state, errMsg, refetch, errorActionSlot }) {
  switch (state) {
    case states.empty:
      return (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className={styles.empty} />
      );

    case states.error:
      return (
        <FetchError
          text={errMsg}
          refetch={refetch}
          actionSlot={errorActionSlot}
        />
      );

    default:
      return null;
  }
}
